import { render, staticRenderFns } from "./UpdateAddressForm.vue?vue&type=template&id=6a13b056&scoped=true"
import script from "./UpdateAddressForm.vue?vue&type=script&lang=ts"
export * from "./UpdateAddressForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13b056",
  null
  
)

export default component.exports